/**
 * Returns the current page direction as "rtl" | "ltr".
 * Reads document.documentElement.dir directly — authoritative, never stale.
 */
export function usePageDirection(): "rtl" | "ltr" {
  return document.documentElement.dir === "ltr" ? "ltr" : "rtl";
}